import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BOGOF_STORE_KEY, BogofState } from './bogof.state';

export const selectBogofFeature = createFeatureSelector<BogofState>(BOGOF_STORE_KEY);

export const selectBogofData = createSelector(
  selectBogofFeature,
  (state: BogofState) => state.data,
);

export const selectBogofIsLoaded = createSelector(
  selectBogofFeature,
  (state: BogofState) => state.isLoaded,
);

export const selectBogofIsLoading = createSelector(
  selectBogofFeature,
  (state: BogofState) => state.isLoading,
);
